import Vue from 'vue'
import VueI18n from 'vue-i18n'

import ElementLocale from 'element-ui/lib/locale'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import zhLocaleTW from 'element-ui/lib/locale/lang/zh-TW'


import langZh from "../langs/zhKey.js"
import langZhTW from "../langs/zhTWKey.js"
import langEN from "../langs/enKey.js"
import {getLanguage} from '@/utils/auth.js'
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: getLanguage()||'zh-CN',
  silentTranslationWarn: true,//关闭全部由未翻译关键字造成的警告
  messages: {
    'zh-CN': {...langZh,...zhLocale},
    'zh-TW': {...langZhTW,...zhLocaleTW},
    'en': {...langEN,...enLocale}
  }
})
ElementLocale.i18n((key, value) => i18n.t(key, value))

export default i18n